import {
  Component,
  OnInit,
  Output,
  OnDestroy,
  EventEmitter,
  AfterViewInit,
} from "@angular/core";
import "intl-tel-input";
import { EmitterService } from "../../services/emitter.service";
import { UserDetailsService } from "../../services/user-details.service";
import { AppDetailsService } from "../../services/app-details.services";
import { Utility } from "../../shared/utility/utility";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { ProfileSettingService } from "../../services/profile-setting.service";
import { CountryDataService } from "../../services/country.service";
import { TranslateService } from "@ngx-translate/core";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { environment } from '../../../environments/environment';
import * as $ from "jquery";
import { coolOffJurisdictions } from "../../shared/utility/config"
@Component({
  selector: "app-complete-profile",
  templateUrl: "./complete-profile.component.html",
  styleUrls: ["./complete-profile.component.scss"],
})
export class CompleteProfileComponent implements OnInit, OnDestroy,AfterViewInit {
  userDeatil;
  moduleOpen;
  userDetails;
  completeUser;
  isCompleteUser;
  isConfirmId;
  isKycBlocked: boolean = false;
  isVerified: boolean = false;
  isInitiated: boolean = false;
  isNew: boolean = false;
  langCode;
  isCompleteProfile: boolean = false;
  addressStatusPending: boolean = false;
  showInitiatedOrVerifiedComponent = false;
  siteUrlPath: string = environment.siteUrl;
  mediaPath = environment.mediaPath;
  windowType;
  balanceInfoCardBg: string = this.siteUrlPath + "/" + this.mediaPath + "/balance-info-card-bg.png";
  userCashBalance = 0;
  userBonusBalance = 0;
  userTotalBalance = 0;
  userCurrencySymbol = this.userDetailsService.getZimplerDefaultCurrencySybmol();
  @Output() callingFrom;
  @Output() triggerAccountMenu = new EventEmitter<any>();
  activatedRouteSub$: Subscription;
  destroy$: Subject<boolean> = new Subject<boolean>();

  prevUrl;
  isCountryAllowed: any;
  jurisdiction: string = '';
  constructor(
    private emitterService: EmitterService,
    private userDetailsService: UserDetailsService,
    private appDetails: AppDetailsService,
    private utils: Utility,
    private router: Router,
    private profileSettingService: ProfileSettingService,
    private activatedRoute: ActivatedRoute,
    private countryDataService: CountryDataService,
    private translateService: TranslateService
  ) {

    this.langCode = localStorage.getItem("langCode");
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
        this.langCode = langCode;
      }
    );

    this.emitterService.isCountryAllowed$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isCountryAllowed = data;
    })
    
    this.emitterService.userDataSource$.pipe(takeUntil(this.destroy$)).subscribe(userDataSource => {
        this.userDetails = userDataSource;
        if (userDataSource === "User Data Updated") {
          this.updateBalanceDetails();
          this.userDetails = this.userDetailsService.getUserProfileDetails();
          Promise.resolve(this.userDetailsService.checkUserProfile()).then(
            (profileData) => {
              if (profileData && profileData["userProfileCompleted"]) {
                this.isCompleteUser = true;
              } else {
                this.isCompleteUser = false;
              }
            }
          );
        }
      }
    );

    /* On deposit successfull, need to check and enable / disable the confirm identity button based on
    life time deposits and withdrawals
    */
    // this.emitterService.txnComplete$.pipe(takeUntil(this.destroy$)).subscribe(transactionStatus => {
    //     if (transactionStatus === "SUCCESS") {
    //       this.checkConfirmIdentity();
    //     }
    //   }
    // );

    // this.checkConfirmIdentity();

    emitterService.modalClose$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.moduleOpen = null;
    });

    let avCountryData = this.appDetails.getAvailableCountries();
    if (window.location.href.indexOf("page=") >= 0) {
      this.router.navigate([], {
        queryParams: { page: null },
        queryParamsHandling: "merge",
      });
    }

    // Open preference modal
    this.activatedRouteSub$ = this.activatedRoute.queryParamMap.subscribe(
      (queryParams) => {
        this.prevUrl = queryParams.get("prevUrl");
        if (queryParams.get("openModal") === "preferences") {
          this.openModal(
            "myaccount/prefferencecenter",
            "completeProfile",
            "prepferences"
          );
        }
        if (queryParams.get("page") === "realitycheck") {
          this.openModal(
            "myaccount/realitycheck",
            "completeProfile",
            "realityCheck"
          );
        }

        if(this.activatedRouteSub$) this.activatedRouteSub$.unsubscribe();
      }
    );

  }
  ngOnInit() {
    this.emitterService.broadcastActiveTabChangeSource("myAccount");
    Promise.resolve(this.profileSettingService.getProfileData(false)).then(
      (profileData) => {
        this.userDetails = profileData;
        this.jurisdiction = profileData?.jurisdiction?.toLowerCase() || '';
        Promise.resolve(this.userDetailsService.checkUserProfile()).then(
          (profileData) => {
            if (profileData && profileData["userProfileCompleted"]) {
              this.isCompleteUser = true;
            } else {
              this.isCompleteUser = false;
            }
          }
        );
      }
    );
    window["prerenderReady"] = true;
    this.isCountryAllowed = this.emitterService.getIsCountryAllowed();
    this.updateBalanceDetails();
  }

  updateBalanceDetails(){
    this.userBonusBalance = this.userDetailsService.getUserBonusBalance();
    this.userCashBalance = this.userDetailsService.getUserCashBalance();
    this.userTotalBalance = this.userDetailsService.getUserTotalBalance();
  }

  ngAfterViewInit() {
    this.resizeWindow();

    setTimeout(() => {
     
      this.router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
        if (event instanceof NavigationEnd) {
  
          const ww = document.body.clientWidth;
  
          if(window.location.search==="" && window.location.pathname==="/"+this.langCode+'/myaccount' && ww > 767){
  
            let params:any={'showAccount':true};
            params.time=new Date().getTime();
  
            this.router.navigate(
              [this.langCode], 
              {
                queryParams: params
              }).then(()=>{
                history.replaceState(null,"", this.router.createUrlTree([this.langCode]).toString())
              });
          }
        }
      
      });

    });
  }
//Legacy
  // checkConfirmIdentity() {
  //   Promise.all([
  //     this.userDetailsService.getAccountVerificationStatus(),
  //     this.userDetailsService.getUserLifeTimeTransactionSummary(),
  //   ]).then((data) => {
  //     if (data) {
  //       let confirmationofIdentityStatus = this.userDetailsService.checkConfirmationofIdentity(
  //         data
  //       );

  //       this.isKycBlocked = confirmationofIdentityStatus.isKycBlocked;
  //       this.isVerified = confirmationofIdentityStatus.isVerified;
  //       this.isNew = confirmationofIdentityStatus.isNew;
  //       this.isInitiated = confirmationofIdentityStatus.isInitiated;
  //       this.showInitiatedOrVerifiedComponent =
  //         confirmationofIdentityStatus.showInitiatedOrVerifiedComponent;
  //     }
  //   });
  // }
  // confirmIdentity() {
  //   this.router.navigate(["myaccount/confirmidentity"], {
  //     queryParamsHandling: "preserve",
  //   });
  // }
  // updateDetails() {
  //   this.router.navigate(["myaccount/profile"], {
  //     queryParamsHandling: "preserve",
  //   });
  // }
  // prefferenceCenter() {
  //   this.router.navigate(["myaccount/prefferencecenter"], {
  //     queryParamsHandling: "preserve",
  //   });
  // }
  // pagenotfound() {
  //   this.router.navigate(["pagenotfound/pagenotfound"], {
  //     queryParamsHandling: "preserve",
  //   });
  // }
  // countryblocked() {
  //   this.router.navigate(["country-blocked/countryblocked"], {
  //     queryParamsHandling: "preserve",
  //   });
  // }

  // changePwd() {
  //   this.router.navigate(["myaccount/changepwd"], {
  //     queryParamsHandling: "preserve",
  //   });
  // }
  // setLimits() {
  //   this.router.navigate([this.langCode + "myaccount/setLimits"], {
  //     queryParamsHandling: "preserve",
  //   });
  // }
  // realityCheck() {
  //   this.router.navigate(["myaccount/realityCheck"], {
  //     queryParamsHandling: "preserve",
  //   });
  // }
  // accountStatus() {
  //   this.router.navigate(["myaccount/accountStatus"], {
  //     queryParamsHandling: "preserve",
  //   });
  // }
  shouldShowErrors(fieldName, formName) {
    return this.utils.shouldShowErrors(fieldName, formName);
  }
  getErrorMessage(fieldName, formName) {
    return this.utils.getErrorMessage(fieldName, formName);
  }
  getButtonClass(formName, fieldName) {
    return this.utils.getButtonClass(formName, fieldName);
  }
  isButtonDisabled(formName) {
    return this.utils.isButtonDisabled(formName);
  }

  openPageOrModal(page, modalId, moduleOpen) {
    localStorage.removeItem('showRegisterPage');
    this.isCompleteProfile = true;
    if (
      moduleOpen === "confirmIdentity" ||
      moduleOpen === "verificationInitiated" ||
      moduleOpen === "verified" ||
      moduleOpen === "updateDetails"
    ) {
      if (this.isCompleteUser || this.userDetailsService.isRealUserAccount()) {
        if (moduleOpen === "confirmIdentity") {
          this.showInitiatedOrVerifiedComponent = false;
          setTimeout(() => {
            this.openModal(page, modalId, moduleOpen);
          }, 1000);
        } else if (
          moduleOpen === "verificationInitiated" ||
          moduleOpen === "verified"
        ) {
          this.showInitiatedOrVerifiedComponent = true;
          setTimeout(() => {
            this.openModal(page, modalId, moduleOpen);
          }, 1000);
        } else if (moduleOpen === "updateDetails") {
          if (this.userDetails && this.countryDataService.getCountries()) {
            this.openModal(page, modalId, moduleOpen);
          } else {
            setTimeout(() => {
              this.emitterService.broadcastserverError(
                this.translateService.instant("errors.error"),
                "/myaccount"
              );
            }, 1000);
          }
        } else {
          this.openModal(page, modalId, moduleOpen);
        }
      } else {
        if(this.userDetailsService.checkZimplerUpdateOpen() ) {
          this.emitterService.broadCastToggleNavPanel(false);
          this.emitterService.broadCastIsZimplerForm(true)
        } else if(this.userDetailsService.checkZimplerDepositOpen()) {
          this.openModal(page, modalId, moduleOpen);
        } else if(!this.userDetailsService.checkIsPNPUser()) {
          this.goBack();
          this.utils.goToCompleteProfile(true);   
        }
      }
    } else {
      this.openModal(page, modalId, moduleOpen);
    }
  }
  resizeWindow() {
    const ww = document.body.clientWidth;
    if (ww <= 992) {
      this.windowType = "mobile";
    } else {
      this.windowType = "desktop";
    }
  }
  showAccountCards: boolean = true;
  openModal(page, modalId, moduleOpen) {
    if (document.body.clientWidth <= 992) {
      if (moduleOpen === "confirmIdentity") {
        this.emitterService.broadcastIsKycBlocked(this.isKycBlocked);
      }
      this.showAccountCards = false;
      this.moduleOpen = moduleOpen;
    } else {
      this.moduleOpen = moduleOpen;

      setTimeout(() => {
        this.utils.openModal(modalId);
        /*get main page name from url 'myaccount/pagename'*/
        page = page.split("/").length > 1 ? page.split("/")[1] : page;
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: { page: page },
          queryParamsHandling: "merge",
        });
      });
    }
  }
  closeModal(modalId) {
    this.moduleOpen = null;
    this.utils.closeModal(modalId);

    if (this.windowType === 'mobile') {
      if (this.prevUrl) {
        this.router.navigate([this.prevUrl], { queryParams: { page: null, openModal: null }, queryParamsHandling: 'merge' });
      } else {
        this.router.navigate([this.langCode + "/myaccount"], { queryParams: { page: null, openModal: null }, queryParamsHandling: 'merge' });
      }
    } else {
      this.router.navigate([this.langCode + "/"]);
    };
    this.resizeWindow();
  }

  update(event) {
    if (event === "completeProfileSuccess") {
      this.isInitiated = true;
      this.isVerified = false;
      this.isNew = false;
      //  this.addressStatusPending= false;
    } else if (event === "goback") {
    /*  else if(event == "photoUploadSuccess"){
     this.addressStatusPending= true;
     } */
      this.openPageOrModal(
        "myaccount/accountstatus",
        "completeProfile",
        "accountStatus"
      );
    } else if (event === "gamingCheck") {
      this.openPageOrModal(
        "myaccount/realitycheck",
        "completeProfile",
        "realityCheck"
      );
    }
    // else if(event == 'initiated'){
    //  this.openPageOrModal('awaitingconfirmation','completeProfile', 'awaitingconfirmation');
    // }
  }
  doLogout() {
    this.userDetailsService.doLogout(true);
    this.utils.clearGamesAndLobbysData();
  }
  accountCardClose() {

    if(this.moduleOpen==='preferences' && this.windowType === 'mobile'){

      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { openModal: null },
        queryParamsHandling: "merge",
      });
    }

    this.showAccountCards = true;
    this.moduleOpen = undefined;
  }

  navigateToUpdateProfile() {
   if(this.utils.isMobile()){
    $('#navPanelToggle').hide();
   }
    localStorage.removeItem('showRegisterPage');
    Promise.resolve(this.userDetailsService.checkUserProfile()).then(
      (profileData) => {
        if (!profileData) {
          const serverError = this.translateService.instant("errors.error1"); //"Server is facing some error.";
          this.emitterService.broadcastserverError(
            serverError,
            this.router.url
          );
          return;
        }
        if ((profileData && !profileData["userProfileCompleted"]) && !this.userDetailsService.isRealUserAccount()) {
          if(this.userDetailsService.checkZimplerUpdateOpen()) {
            this.emitterService.broadCastToggleNavPanel(false);
            this.emitterService.broadCastIsZimplerForm(true)
          } else if(this.userDetailsService.checkZimplerDepositOpen()){
            this.triggerAccountMenu.emit('UPDATEPROFILE');
          } else if(!this.userDetailsService.checkIsPNPUser()) {
            this.goBack();
            this.utils.goToCompleteProfile(true);
          }

          return;
        }
        else{
          this.triggerAccountMenu.emit('UPDATEPROFILE');
        }
        
      }
    );
    
  }
  navigateToPassword() {
    this.triggerAccountMenu.emit('CHANGEPASSWORD');
  }
  navigateToPreference() {
    this.triggerAccountMenu.emit('PREFERENCE');
  }

  goBack() {
    this.utils.setIsSideMenuOpened(true);
    this.emitterService.broadCastToggleNavPanel({isBack:true, opened:true});
  }
  openCoolOffPopup(): void {
 
    this.utils.openModal('coolOffModal');
  }

  isCoolOffAvailable():boolean{
    return (  environment.coolOff.enabled && coolOffJurisdictions.includes(this.jurisdiction))
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.moduleOpen = undefined;
    this.showAccountCards = true;
    if(this.activatedRouteSub$) this.activatedRouteSub$.unsubscribe();
  }
}
